// Пример простого Tooltip компонента (создайте его где-то, например, Tooltip.tsx)
// Tooltip.tsx
import React, { useState } from "react";
import styles from "./Tooltip.module.css";

type TooltipProps = {
  content: React.ReactNode;
  children: React.ReactNode;
  wrapperClassName?: string;
};

const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  wrapperClassName,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      className={`${styles.tooltipWrapper} ${wrapperClassName}`}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && <div className={styles.tooltipContent}>{content}</div>}
    </div>
  );
};

export default Tooltip;
